/* ============================================
   SARAI COSMETICS — Scroll-Triggered Animations
   ============================================ */
(function() {
  'use strict';

  // Transparent header is now handled by Liquid (header.liquid)

  // Elements to animate on scroll
  const selectors = [
    '.section__heading',
    '.banner__heading',
    '.banner__subheading',
    '.banner__text',
    '.banner__buttons',
    '.rich-text__heading',
    '.rich-text__text',
    '.rich-text .button',
    '.image-with-text__media-item',
    '.image-with-text__text-item',
    '.card-wrapper',
    '.multicolumn-card',
    '.gallery__item',
    '.logo-list__item',
    '.testimonials blockquote',
    '.testimonials__slide',
    '.guarantees__item',
    '.icon-with-text__item',
    '.newsletter__wrapper',
    '.timeline__item',
    '.collapsible-content__item',
    '.contact-form',
    '.footer__content-top'
  ];

  function init() {
    // Add reveal class to all target elements
    const elements = document.querySelectorAll(selectors.join(', '));

    elements.forEach(function(el, index) {
      if (!el.classList.contains('scroll-reveal')) {
        el.classList.add('scroll-reveal');
        // Stagger siblings (cards in a grid)
        const parent = el.parentElement;
        if (parent) {
          const siblings = Array.from(parent.children).filter(function(child) {
            return child.classList.contains('scroll-reveal');
          });
          const siblingIndex = siblings.indexOf(el);
          if (siblingIndex > 0) {
            el.style.transitionDelay = (siblingIndex * 0.1) + 's';
          }
        }
      }
    });

    // IntersectionObserver for revealing elements
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('scroll-reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -40px 0px'
      });

      document.querySelectorAll('.scroll-reveal').forEach(function(el) {
        observer.observe(el);
      });
    } else {
      // Fallback: show everything
      document.querySelectorAll('.scroll-reveal').forEach(function(el) {
        el.classList.add('scroll-reveal--visible');
      });
    }
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init after Shopify section renders (theme editor compatibility)
  document.addEventListener('shopify:section:load', init);
})();
